declare global {
	interface Window {
		/**
		 * Runtime environment injected by the Docker container at start-up.
		 * Populated by /config.js (see docker-runtime-config.sh). Empty in local dev.
		 */
		__ENV__?: Record<string, string>;
	}
}

/**
 * Merged runtime + build-time environment.
 *
 * `window.__ENV__` is generated at container start by the Docker runtime-config
 * script (served as `/config.js`) from the container's environment variables. Those
 * values override the build-time values Vite inlined via `import.meta.env`, so a
 * single built image can be deployed to every environment (test / acc / prod).
 *
 * In local dev `__ENV__` is empty and the app falls back to `import.meta.env`
 * (loaded from `.env`). Import this `env` object instead of reading
 * `import.meta.env` directly for any value that varies per environment.
 *
 * Note: Vite build-time flags such as `import.meta.env.PROD` are NOT environment
 * aware here — a production build has `PROD === true` even when deployed to test.
 * Use `env.VITE_NODE_ENV` to distinguish deploy environments at runtime.
 */
export const env: Record<string, any> = {
	...import.meta.env,
	...(typeof window !== 'undefined' ? window.__ENV__ ?? {} : {}),
};
